import { Directive, forwardRef, Attribute, ElementRef, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[appValidatePasswordPolicy]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => PasswordPolicyValidator), multi: true }
  ]
})
export class PasswordPolicyValidator implements Validator {

  private static digitRegExp = new RegExp('[0-9]');

  private static uppercaseRegExp = new RegExp('[A-Z]');

  private static lowercaseRegExp = new RegExp('[a-z]');

  @Input()
  minLength: number;

  @Input()
  lowercase: boolean;

  @Input()
  uppercase: boolean;

  @Input()
  numbers: boolean;

  constructor(

  ) {
    this.minLength = 8;
    this.lowercase = true;
    this.uppercase = true;
    this.numbers = true;
  }

  validate(control: AbstractControl): { [key: string]: any } {

    const controlValue = control.value as string;
    if (!controlValue || controlValue.length < this.minLength) {
      return { minLengthLimitationViolated: true };
    }

    if (this.uppercase && !PasswordPolicyValidator.uppercaseRegExp.test(controlValue)) {
      return { uppercaseLimitationViolated: true };
    }

    if (this.lowercase && !PasswordPolicyValidator.lowercaseRegExp.test(controlValue)) {
      return { lowercaseLimitationViolated: true };
    }

    if (this.numbers && !PasswordPolicyValidator.digitRegExp.test(controlValue)) {
      return { numbersLimitationViolated: true };
    }

    return null;
  }
}
